import { render, staticRenderFns } from "./SerialManagement.vue?vue&type=template&id=64361aeb&"
import script from "./SerialManagement.vue?vue&type=script&lang=js&"
export * from "./SerialManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports